<template>
  <div class="background">
    <div class="row">
      <div class="col-sm-12 text-center" style="position:fixed; top: 15%;">
        <!-- <img src="~../assets/image/logo_L_size.png" style="position:fixed; left:3em; top: 3em; max-height: 10vw; max-width: 15vw;" /> -->
        <div class="pb-3 pt-3">
          <img src="~../assets/image/logo_L_size.png" class="logo ml-3">
        </div>
        <!-- <button class="btn btn-primary">下載App</button> -->
        <button class="btn btn-primary" @click.stop.prevent="$router.push({ name: 'login' })">{{ $t('login') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Main'

}
</script>

<style lang="scss" scoped>
  @import '../assets/style/color.scss';

  .background {
    position: relative;
    width: 100%;
    height: calc(100vh - 126px);
    background-image: url('~../assets/image/bg.jpg');
    background-size: cover;
    background-position: center center;
  }

  .btn-primary {
    font-weight: 700;
    letter-spacing: 3px;
    background-color: #fff;
    border-color: $main-color;
    color: $main-color!important;
    padding-left: 1.25em;
    padding-right: 1.25em;

    &:hover {
      background-color: $main-color;
      color: #fff!important;
    }
  }

  @media screen and (max-width: 576px) {
    .logo {
      max-width: 80%;
    }
  }

</style>


// WEBPACK FOOTER //
// Main.vue?23dcbb92